module.exports = __webpack_public_path__ + "img/img14.66739e38.svg";